import type { TFunction } from 'i18next';
import type { Forholdtype } from '@origo/planregister';
import type { SelectOption, PlanBadge } from '../types';

const CODES: Forholdtype[] = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];

export function forholdtypeLabel(code: Forholdtype | string | undefined, t: TFunction): string {
    if (!code) return '';
    return t(`codelists.forholdtype.${code}`, { defaultValue: code });
}

export function forholdtypeOptions(t: TFunction): SelectOption[] {
    return CODES.map(code => ({ value: code, label: forholdtypeLabel(code, t) }));
}

export function forholdtypeBadge(code: Forholdtype | string | undefined, t: TFunction): PlanBadge {
    return { label: forholdtypeLabel(code, t), variant: 'info' };
}
